import {
  SCAN_COMPLETED_FRONT,
  SCAN_STARTED_FRONT,
  SCAN_COMPLETED_BACK,
  SCAN_STARTED_BACK,
  IMAGE_TYPE_FRONT,
  IMAGE_TYPE_BACK,
  OCR_DATA,
  OCR_DATA_BACK,
  SET_CARD_ID_FRONT,
  SET_CARD_ID_BACK,
  CLEAR_ADD_INSURANCE_FORM_DATA,
  CLEAR_CARD_DATA,
  SET_ADD_INSURANCE_FORM_DATA,
} from '../constants';
import { zipObj } from '../core/util/object';

const toZip = zipObj([IMAGE_TYPE_FRONT, IMAGE_TYPE_BACK]);

// order matters for the list you give typeAssign. The first element will be assigned to front
const startedMap = toZip([SCAN_STARTED_FRONT, SCAN_STARTED_BACK]);
const completedMap = toZip([SCAN_COMPLETED_FRONT, SCAN_COMPLETED_BACK]);
const ocrMap = toZip([OCR_DATA, OCR_DATA_BACK]);
const cardIdMap = toZip([SET_CARD_ID_FRONT, SET_CARD_ID_BACK]);

const scanStarted = imageType => ({
  type: startedMap[imageType],
  payload: { value: true },
});

const scanCompleted = (imageType, error) => ({
  type: completedMap[imageType],
  payload: { value: true, error },
});

const setOcrData = (value, imageType) => ({
  type: ocrMap[imageType],
  payload: { value },
});

const setCardId = (value, imageType) => ({
  type: cardIdMap[imageType],
  payload: { value },
});

const setFormData = value => ({
  type: SET_ADD_INSURANCE_FORM_DATA,
  payload: { value },
});

const clearCardData = () => ({
  type: CLEAR_CARD_DATA,
  payload: {},
});

const clearFormData = () => ({
  type: CLEAR_ADD_INSURANCE_FORM_DATA,
  payload: {},
});

export {
  scanStarted,
  scanCompleted,
  setOcrData,
  setCardId,
  setFormData,
  clearCardData,
  clearFormData,
};
